import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  APP_LOADED,
  MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";
import * as actions from '../../actions/auth';
import './index.scss';
import {isSessionTerminated} from "../../api/api";
import {getApplianceUrl, getOrigin, getSessionToken, setApplianceUrl} from "../../actions/storage";

export class Auth extends Component {
  handleFrameLoaded = (e) => {
    window.parent.postMessage(APP_LOADED, getOrigin());
  }
  handleFrameTasks = (e) => {
    if (typeof e.data === "string" && !this.props.credentials) {
      const {authToken, idpInstanceId, applianceUuid, capabilities, extendedAttributes, applianceUrl} = JSON.parse(
          e.data);
      const authSessionToken = getSessionToken();
      if (authToken && idpInstanceId && applianceUuid) {
        if (authSessionToken !== null && !isSessionTerminated(authSessionToken)
            && this.isSameApplianceSession(applianceUrl)) {
          this.props.history.push(
              this.props.history.location.state.previousPage);
          return;
        }

        var hybridUicapabilities = [];
        capabilities.filter(
            object => object.name === "HybridUI")
        .forEach(object => hybridUicapabilities = hybridUicapabilities.concat(
            object.capabilities));

        if (hybridUicapabilities.length > 0) {
          this.props.mapAndStoreCapabilities(hybridUicapabilities);
        }
        if (extendedAttributes) {
          this.props.mapAndStoreExtendedAttributes(extendedAttributes);
        }
        setApplianceUrl(applianceUrl || e.origin);
        this.props.auth(authToken, idpInstanceId, applianceUuid, hybridUicapabilities);
      }
    }
  }

  isSameApplianceSession = (applianceUrl) => {
    if (applianceUrl) {
      return getApplianceUrl() === applianceUrl;
    } else {
      return true;
    }
  }

  componentDidMount() {
    window.addEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
    this.handleFrameLoaded();
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
  }

  componentDidUpdate() {
    if (this.props.credentials && this.props.credentials.authSessionToken) {
      if (this.props.history.location.state && !isSessionTerminated(
          this.props.credentials.authSessionToken)) {
        this.props.history.push(this.props.history.location.state.previousPage);
      } else {
        this.props.history.push("/");
      }
    }
  }

  render() {
    if (this.props.errorMsg) {
      return (
          <div className="auth-container">Unauthorized</div>
      );
    }
    return (
        <div className="auth-container"/>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    credentials: state.auth.credentials,
    errorMsg: state.auth.errorMsg,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    auth: (authToken, idpInstanceId, applianceUuid, capabilities) => {
      dispatch(actions.auth(authToken, idpInstanceId, applianceUuid, capabilities));
    },
    mapAndStoreCapabilities: (capabilities) => {
      dispatch(actions.mapAndStoreCapabilities(capabilities));
    },
    mapAndStoreExtendedAttributes: (extendedAttributes) => {
      dispatch(actions.mapAndStoreExtendedAttributes(extendedAttributes))
    }
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Auth);



// WEBPACK FOOTER //
// ./src/components/Auth/index.js